'use client';
import React from 'react';
import PostItem from '../post-items/sub-components/post-item';
import CurveContainer from '@elements/curve-container';
import { useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import { Div } from '@pezeshk-book/ui-kit';

const ExtendedPostItems = () => {
  const { blogList } = useSelector((state: RootState) => state.blogs);

  if (blogList && blogList.length) {
    return (
      <Div className={'relative flex-col w-full'}>
        {blogList.map((item: any, index: number) => (
          <CurveContainer key={`postItemsData${index}`} gray={index % 2 === 0}>
            <Div className={'w-full flex-col'}>
              <PostItem
                slug={item?.slug}
                title={item?.title}
                row={index % 2 === 0}
                image={item?.image?.key_0?.url || '/images/default.jpg'}
                context={item?.description}
                typeTitle={item?.type?.title}
                dislike={item?.dislike || 0}
                like={item?.like || 0}
                publishedAt={item?.published_at}
              />
            </Div>
          </CurveContainer>
        ))}
      </Div>
    );
  }

  return null;
};

export default ExtendedPostItems;
